module.exports = __webpack_public_path__ + "static/media/Allan Clarke.2d579c6f.JPG";